import _ from "lodash";
// import { getField, updateField } from 'vuex-map-fields';

export default {
  // namespaced: true,
  state: {
    changesToBeMade: {},
    status: {
      house: 3,
      transport: 3,
      personal: 3,
      eatout: 3,
      holiday: 3,
      food: 3,
      leisure: 3,
      communications: 3,
      health: 3,
    },
    lastItem: '',
    itemHistory: [],
  },
  getters: {
    // getField,
    futureStatus: state => {
      return _.defaults(state.changesToBeMade, state.status);
    },

    activeItem: (state, getters) => {

      if (state.lastItem === '') {
        return {};
      }

      return {
        name: state.lastItem,
        status: getters.futureStatus[state.lastItem],
      };
    },

    answers: (state) => {
      return state.status;
    },
  },

  mutations: {
    // updateField,
    selectHouseStatus(state, status) {
      state.changesToBeMade['house'] = status;
      state.itemHistory.push('house');
    },
    selectCommunicationsStatus(state, status) {
      state.changesToBeMade['communications'] = status;
      state.itemHistory.push('communications');
    },
    selectTransportStatus(state, status) {
      state.changesToBeMade['transport'] = status;
      state.itemHistory.push('transport');
    },
    selectPersonalStatus(state, status) {
      state.changesToBeMade['personal'] = status;
      state.itemHistory.push('personal');
    },
    selectEatoutStatus(state, status) {
      state.changesToBeMade['eatout'] = status;
      state.itemHistory.push('eatout');
    },
    selectHolidayStatus(state, status) {
      state.changesToBeMade['holiday'] = status;
      state.itemHistory.push('holiday');
    },
    selectFoodStatus(state, status) {
      state.changesToBeMade['food'] = status;
      state.itemHistory.push('food');
    },
    selectLeisureStatus(state, status) {
      state.changesToBeMade['leisure'] = status;
      state.itemHistory.push('leisure');
    },
    selectHealthStatus(state, status) {
      state.changesToBeMade['health'] = status;
      state.itemHistory.push('health');
    },

    applyChangesToScene(state) {
      _.forEach(state.changesToBeMade, (value, key) => {
        state.status[key] = value;
      });

      state.changesToBeMade = {};
    },

    moveToItem(state, itemName) {
      state.lastItem = itemName;
    },

    resetScene(state) {
      state.changesToBeMade = {};
      _.each(state.status, (value, key) => {
        state.status[key] = 0;
      });
    },
  },
  actions: {
    goToItem({ commit, rootState }, itemName) {
      rootState.ui.isAnimating = true;
      rootState.ui.showForeground = false;

      commit('moveToItem', itemName);
    },
    resetLastItem({ dispatch, commit, rootState }) {
      rootState.scene.changesToBeMade[_.last(rootState.scene.itemHistory)] = 0;
      rootState.scene.itemHistory.pop();

      rootState.ui.lastVisitedPageIndex = rootState.ui.currentPageIndex;
      rootState.ui.currentPageIndex = Math.max(0, rootState.ui.currentPageIndex - 1);

      if (_.last(rootState.scene.itemHistory)) {
        commit('goToPreviousPage');
        commit('applyChangesToScene');

        dispatch('goToItem', _.last(rootState.scene.itemHistory));

      } else {
        // back to start, reset
        rootState.scene.lastItem = '';
        commit('goToPreviousPage');
        commit('resetScene');
      }
    },
  },
};
